import apiClient from "./apiClient";

export const getAllFrameworks = async (page, per_page) => {
  try {
    const response = await apiClient.get(
      `/admin/framework/get-all-framework?page=${page}&per_page=${per_page}`,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFrameworkById = async (id) => {
  try {
    const response = await apiClient.get(
      `/admin/framework/${id}`,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createFrameworks = async (payload) => {
  try {
    const response = await apiClient.post(
      `/admin/framework/create`, payload,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateFrameworks = async (id, payload) => {
  try {
    const response = await apiClient.put(
      `/admin/framework/edit/${id}`, payload,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteFrameworks = async (id) => {
  try {
    const response = await apiClient.put(
      `/admin/framework/delete/${id}`,
      {
        headers: {
          organization_id: 1,
          website_id: 1,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
